import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { AzureAvatarConfig } from "@models/avatar-config";
import { DateTime } from 'luxon';

const BACKGROUND_IMAGES: Record<string, string[]> = {
  "morning": [
    "kitchen-1.jpeg",
    "living-1.jpeg",
  ],
  "afternoon": [
    "office-1.jpeg",
    "office-2.jpeg",
    "outdoor-1.jpeg",
    "outdoor-2.jpeg",
  ],
  "evening": [
    "kitchen-1.jpeg",
    "living-1.jpeg",
  ],
  "night": [
    "bedroom-1.jpeg",
  ],
}

export class AzureAvatarHelper {
  static createAvatarSynthesizer(config: AzureAvatarConfig) {
    const {
      accessToken,
      region,
      avatarConfig: {
        voiceName,
        character,
        style,
        language,
      }
    } = config;

    const getBackgroundImage = (): URL | undefined => {
      if (!process.env.REACT_APP_PUBLIC_URL) {
        return;
      }
      const currentHour = DateTime.now().hour;
      let dayTime: string;
      if (currentHour >= 3 && currentHour < 12) {
        dayTime = "morning";
      } else if (currentHour >= 12 && currentHour < 15) {
        dayTime = "afternoon";
      } else if (currentHour >= 15 && currentHour < 20) {
        dayTime = "evening";
      } else {
        dayTime = "night";
      }
      const images = BACKGROUND_IMAGES[dayTime];
      return new URL(`${process.env.REACT_APP_PUBLIC_URL}/images/background/${images[Math.floor(Math.random()*images.length)]}`);
    };

    const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
      accessToken,
      region,
    );
    speechConfig.speechSynthesisVoiceName = voiceName;
    if (language) {
      speechConfig.speechSynthesisLanguage = language;
    }

    const videoFormat = new SpeechSDK.AvatarVideoFormat();
    let videoCropTopLeftX = 600;
    let videoCropBottomRightX = 1320;
    videoFormat.setCropRange(
      new SpeechSDK.Coordinate(videoCropTopLeftX, 50),
      new SpeechSDK.Coordinate(videoCropBottomRightX, 1080),
    );

    const avatarConfig = new SpeechSDK.AvatarConfig(
      character,
      style,
      videoFormat,
    );
    const backgroundImageUrl = getBackgroundImage();
    console.log(`Avatar with backgroundImageUrl ${backgroundImageUrl}`);
    if (backgroundImageUrl) {
      avatarConfig.backgroundImage = backgroundImageUrl;
    }

    return new SpeechSDK.AvatarSynthesizer(speechConfig, avatarConfig);
  }

  static createWebRTCConnection(
    config: AzureAvatarConfig,
    onConnect: (e: RTCTrackEvent) => void,
  ) {
    const {
      iceServers: { urls, password, username },
    } = config;
    const peerConnection = new RTCPeerConnection({
      iceServers: [
        {
          urls,
          username,
          credential: password,
        },
      ],
    });

    peerConnection.ontrack = onConnect;
    // This is a workaround to make sure the data channel listening is working by creating a data channel from the client side
    peerConnection.createDataChannel("eventChannel");
    peerConnection.addTransceiver("video", { direction: "sendrecv" });
    peerConnection.addTransceiver("audio", { direction: "sendrecv" });

    return peerConnection;
  }
}
